import { helpers, React, ts, ui, useSelector } from '_core';

import { prepareData } from './helpers';

type ChartProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  file: string;
  title: string;
  fullScreen?: boolean;
};

const Chart = ({ id, readOnly, loadWidgetData, file, title, fullScreen = false }: ChartProps) => {
  const resources = useSelector((state) => state.resources);
  const [data, setData] = React.useState<ts.types.widgets.TableData>(null);
  const [error, setError] = React.useState<ts.types.common.ApiError>(null);

  const loadData = async () => {
    try {
      const response = await loadWidgetData({
        data: { file },
      });
      if (response?.data) {
        setData(prepareData(response.data, resources));
      }
    } catch (err) {
      setError(err as ts.types.common.ApiError);
    }
  };

  React.useEffect(() => {
    if (file) loadData();
    return () => setData(null);
  }, [file]);

  return (
    <ui.LineChart
      id={id}
      data={data}
      fullScreen={fullScreen}
      readOnly={readOnly}
      alert={error ? { type: 'error', message: helpers.parseApiError(error) } : undefined}
      exportTitle={title}
      numberFormat="#.##%"
    />
  );
};

export default Chart;
